import { useEffect, useState } from 'react'
import { useLocal } from '@/hooks/useDatos'

export default function AvisoSuscripcion() {
  const { data: local } = useLocal()

  const [dias, setDias] = useState<number | null>(null)

  useEffect(() => {
    if (local?.trial_hasta) {
      const diff = new Date(local.trial_hasta).getTime() - Date.now()
      setDias(Math.ceil(diff / 86400000))
    } else {
      setDias(null)
    }
  }, [local?.trial_hasta])

  // Si tiene suscripción vitalicia gratis o está activa, no mostrar aviso
  if (!local || local.estado_suscripcion === 'activa' || local.suscripcion_vitalicia_gratis) return null

  const enPrueba = local.estado_suscripcion === 'trial'
  if (enPrueba && (dias === null || dias > 7)) return null

  const vencida = !enPrueba || (dias !== null && dias <= 0)

  return (
    <div className={`rounded-md p-3 text-sm ${vencida ? 'bg-destructive/10 text-destructive' : 'bg-muted'}`}>
      {vencida
        ? 'La suscripción venció: puedes consultar tus datos, pero no crear ni modificar turnos ni clientes.'
        : `Te quedan ${dias} ${dias === 1 ? 'día' : 'días'} de prueba.`}
    </div>
  )
}